import React, { useContext } from 'react';
import { Link } from 'react-router-dom'
import { TrailContext } from './TrailContext';

export default function Footer() {

    const [trails] = useContext(TrailContext);
    const linkStyle = {
        color: 'white',
        textDecoration: 'none',
    }

    return (
        <footer className="footer">
            <div className="section 1 footer__item">
                <h4 className="footer__item__title">Trails:</h4>
                <ul className="footer__item__body">
                    {trails.map(trail => (
                        <li className="footer__link" key={trail.name}><Link style={linkStyle} to={`/trails/${trail.url}`}>{trail.name}</Link></li>
                    ))}
                </ul>
            </div>
            <div className="section2 footer__item">
                <h4 className="footer__item__title">Other:</h4>
                <ul className="footer__item__list">
                    <li className="footer__link"><Link style={linkStyle} to="/">Home</Link></li>
                    <li className="footer__link"><Link style={linkStyle} to="/etiquete">Trail Etiquete</Link></li>
                    <li className="footer__link"><Link style={linkStyle} to="/trails">All Trails</Link></li>
                </ul>
            </div>
            <h4 className="copy">&copy; Evan Chisholm {new Date().getFullYear()}</h4>
        </footer>
    )
}